import { render, staticRenderFns } from "./AllselectModal.vue?vue&type=template&id=64e44adc&scoped=true"
import script from "./AllselectModal.vue?vue&type=script&lang=js"
export * from "./AllselectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e44adc",
  null
  
)

export default component.exports